<template>
  <div>
    <b-card v-for="(todo, key) of todos" :key="key" no-body :class="'mb-4 shadow'">
      <template v-if="messages[todo]">
        <span class="position-absolute setup-icon setup-icon-to-do text-center px-0">
          <font-awesome-icon :icon="'wrench'" :rotation="90" aria-hidden="true" />
        </span>

        <b-card-body class="px-4 py-3 bg-white rounded border flex-grow-0">
          <div class="row align-items-center">
            <div class="col-12 col-md-12 col-xxl-8 text-md-center text-xxl-left">
              <b-card-title class="font-size-14 line-height-5">
                {{ messages[todo].title }}
              </b-card-title>
              <b-card-text class="font-size-14 line-height-4 font-weight-normal">
                {{ messages[todo].description }}
              </b-card-text>
            </div>

            <div class="col-12 col-md-12 col-xxl-4 mt-3 mt-xxl-0 text-center text-xxl-right">
              <router-link class="btn btn-sm m-auto btn-primary px-4" variant="primary" :to="{name: messages[todo].linkName}">
                {{ $t('Go') }}
              </router-link>
            </div>
          </div>
        </b-card-body>
      </template>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "TodoCard",
  data() {
    return {
    };
  },
  computed: {
    todos: function() {
      return this.$store.state.TODOS;
    },
    messages() {
      return  {
        company_details: {
          title: this.$t('Complete Company Details'),
          description: this.$t('Please complete your company details.'),
          linkName: 'dashboard'
        },
        coverage: {
          title: this.$t('Set up Lead Types, Accreditations & Coverage'),
          description: this.$t('Tell us the type of leads you need and where you want to work.'),
          linkName: 'lead-selection-&-coverage-tab-0'
        },
        listing: {
          title: this.$t('Complete your Listing'),
          description: this.$t('Make it easier for customers to find you and showcase your work to win more.'),
          linkName: 'listing'
        },
        missing_payment_method: {
          title: this.$t('Set up Payment'),
          description: this.$t('Add your payment details to continue to buy leads.'),
          linkName: 'payment-methods'
        },
        lead_delivery: {
          title: this.$t('Lead Alert Preferences'),
          description: this.$t('Adjust the quantity of lead alerts you receive and find out more about AutoAccept.'),
          linkName: 'lead-delivery'
        },
        lead_alerts: {
          title: this.$t('Create Lead Alerts'),
          description: this.$t('We\'ll let you know when you have a new lead match in your area.'),
          linkName: 'lead-alerts'
        },
      };
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep .setup-icon-to-do {
  left: -6px;
  top: -6px;
  padding: 0 5px;
  width: 25px;
  height: 25px;
  background: $setup-icon-bg;
  border: 0;
  pointer-events: none;

  .svg-inline--fa {
    width: 0.9em;
    height: 0.8em;
  }
}

@include media-breakpoint-down(sm) {
  ::v-deep .setup-icon-to-do {
    padding: 2px 0;
  }
}

</style>
